import React, { useState, useEffect } from 'react'
import Avatar from "@mui/material/Avatar";

function AddMeetings({ currentAgenda, newProfile, handleNextButton, showProfile }) {
    const [bgColor, setBgColor] = useState("");
    useEffect(() => {
        let color = getRandomColor();
        setBgColor(color);
    },[])

    function getRandomColor() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

  return (
    <div className='w-full h-screen bg-blue-7 md:grid md:justify-items-center md:items-center pl-2 pr-2 pt-12 pb-10 md:pl-56 md:pr-56 md:pb-24 md:pt-10'>
        <div className='justify-items-start w-11/12 -mt-5 mb-6 md:hidden'>
            {localStorage.getItem("boardName")}
        </div>
        <div className='w-auto h-auto bg-white-1 rounded-md pl-6 pt-8 pr-10 pb-8 md:pl-20 md:pr-20 md:pt-10 md:pb-10'>
            <div>
                <img  src='/calendly.png'/>
            </div>
            <div className='mt-6 md:mt-4'>
                <h2 className='md:text-4xl text-xl font-bold font-Poppins'>Schedule a call with {newProfile?.full_name?.split(' ')[0]}'s recruitment manager</h2>
            </div>
            <div className='mt-6 md:mt-4'>
                <h2 className='md:text-lg text-base font-Poppins'>The recruitment manager for {currentAgenda[0]?.full_name} and {newProfile?.full_name} is same. Do you wish to add {newProfile?.full_name?.split(' ')[0]} to your existing meeting?</h2>
            </div>
            <div className='mt-6 md:mt-4'>
                <h2 className='text-base text-[#505050] font-bold  font-Poppins'>Candidates Selected</h2>
            </div>
            
            <div className='mt-6 md:mt-4 flex'>
                <div className='flex flex-wrap justify-start w-full'>
                {/* For new candidate */}
                    <div>
                        {/* DP */}
                        <div className='flex justify-center'>
                            <div style={{backgroundColor: bgColor}} className={`flex items-center justify-center rounded-full w-[60px] h-[60px] hover:border-blue-4 cursor-pointer mb-4 relative`}  onClick={() => showProfile(newProfile?.id)}>
                                <Avatar alt="Profile" src={newProfile?.emoji_url} className="mt-1" imgProps={ {'style':{'objectFit': 'contain'}}} />
                                {/* New tag */}
                                <div className='rounded-md text-sm bg-blue-1 text-center text-white-1 absolute top-0 right-0' style={{width:"27px",height:"12px",textAlign:"center"}} >
                                    <p className='-mt-1' style={{fontSize:"8px"}}>New</p>
                                </div>
                            </div>
                        </div>

                        {/* Full name */}
                        <div className={`w-28 text-center text-black-1 text-sm p-1 rounded-sm border-blue-1 bg-white-1 border font-medium`} onClick={() => showProfile(newProfile?.id)}>
                        {newProfile?.full_name?.split(" ")[0]}
                        </div>
                    </div>

                    {currentAgenda?.length && 
                        currentAgenda.slice(0,1).map((profile, index) => (
                            profile.emoji_url !== newProfile.emoji_url &&
                            <div key={index} className="">
                                <div className='flex justify-center'>
                                    <div style={{backgroundColor: profile.bgColor}} className={`w-[60px] h-[60px] flex items-center justify-center rounded-full hover:border-blue-4 cursor-pointer mb-4 ml-2`}  onClick={() => showProfile(profile?.id)}>
                                        <Avatar alt="Profile" src={profile.emoji_url} className="" imgProps={ {'style':{'objectFit': 'contain'}}} />
                                    </div>
                                </div>
                                
                                <div key={index} className={`w-28 text-center text-black-1 text-sm p-1 ml-2 mb-4 rounded-sm border-blue-1 bg-white-1 border font-medium`} onClick={() => showProfile(profile?.id)}>
                                    {profile.full_name?.split(" ")[0]}
                                </div> 
                            </div>
                        ))
                    }
                    { currentAgenda.length > 1 && 
                                <div>
                                    {/* DP */}
                                    <div className='flex justify-center'>
                                        <div className={`flex items-center justify-center rounded-full w-[60px] h-[60px] hover:border-blue-4 mb-4 bg-[#FFE7E7]`}>
                                            <Avatar alt="Profile" src="user1.png" className="mt-1"/>
                                        </div>
                                    </div>

                                    {/* Full name */}
                                    <div className={`w-28 text-center text-black-1 text-sm p-1 rounded-sm border-blue-1 bg-white-1 border font-medium ml-2`}>
                                    + {currentAgenda.length - 1} more
                                    </div>
                                </div>
                            }
                </div>
            </div>
            
            <div className='grid grid-cols-12 mt-6 md:mt-4'>
                <div className="col-span-5">
                    <button className='bg-blue-8 text-white-1 rounded-sm p-2 w-60' onClick={() => handleNextButton(bgColor)}>Next</button>        
                </div>
                
            </div>
        </div>
    </div> 
  )
}

export default AddMeetings